/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Create_CategoryInputs */

const en_cases_settings_create_category = /** @type {(inputs: Cases_Settings_Create_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create category`)
};

/**
* | output |
* | --- |
* | "Create category" |
*
* @param {Cases_Settings_Create_CategoryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cases_settings_create_category = /** @type {((inputs?: Cases_Settings_Create_CategoryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Create_CategoryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_create_category(inputs)
});